<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Location"
      @click.native.stop
    >
      <v-select
        v-model="locationFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="locationOptions"
        :clearable="false"
        :reduce="name => name._id"
      />
    </b-form-group>
    <b-form-group label="Product Type">
      <b-form-checkbox
        v-for="option in productOptions"
        :key="option.code"
        v-model="productFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Reservable By">
      <b-form-checkbox
        v-for="option in reservableOptions"
        :key="option.code"
        v-model="reservableFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Sales Status">
      <b-form-checkbox
        v-for="option in saleStatusOptions"
        :key="option.code"
        v-model="saleStatusFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,

    vSelect,
  },
  props: {
    location: {
      type: [Array, null],
      default: null,
    },
    locationOptions: {
      type: Array,
      required: true,
    },
    product: {
      type: [Array, null],
      default: null,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    reservable: {
      type: [Array, null],
      default: null,
    },
    reservableOptions: {
      type: Array,
      required: true,
    },
    saleStatus: {
      type: [Array, null],
      default: null,
    },
    saleStatusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      locationFilterValue: JSON.parse(JSON.stringify(this.location)) || [],
      productFilterValue: JSON.parse(JSON.stringify(this.product)) || [],
      reservableFilterValue: JSON.parse(JSON.stringify(this.reservable)) || [],
      saleStatusFilterValue: JSON.parse(JSON.stringify(this.saleStatus)) || [],
    }
  },
  watch: {
    location: {
      immediate: true,
      handler(val) {
        this.locationFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    product: {
      immediate: true,
      handler(val) {
        this.productFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    reservable: {
      immediate: true,
      handler(val) {
        this.reservableFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    saleStatus: {
      immediate: true,
      handler(val) {
        this.saleStatusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:location', this.locationFilterValue)
      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:reservable', this.reservableFilterValue)
      this.$emit('update:saleStatus', this.saleStatusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.locationFilterValue = []
      this.productFilterValue = []
      this.reservableFilterValue = []
      this.saleStatusFilterValue = []

      this.$emit('update:location', this.locationFilterValue)
      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:reservable', this.reservableFilterValue)
      this.$emit('update:saleStatus', this.saleStatusFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
